"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationListFilterCheckboxList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const translations_1 = require("../types/translations");
const FilterCheckbox = ({ name, checked, onChange, label, trackingId }) => {
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { color: "primary", name: name, checked: checked, onChange: onChange }), label: label, "data-tracking-id": trackingId }));
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    filter: {
        padding: theme.spacing(1, 1, 1, 1.5),
    },
}));
const NotificationListFilterCheckboxList = ({ list, state, setState, identifier, }) => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const onChange = (filter) => {
        if ((0, lodash_es_1.includes)(state, filter)) {
            setState(state.filter((selectedFilter) => selectedFilter !== filter));
        }
        else {
            const newState = [...state, filter];
            if (list.length === newState.length) {
                setState([]);
            }
            else {
                setState(newState);
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.filter, direction: "column", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(FilterCheckbox, { name: "all", checked: !state.length, onChange: () => {
                        setState([]);
                    }, label: translate('notification_center-list_filters-all'), trackingId: `notification_list-filters-${identifier}-all` }) }), list.map((filter) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(FilterCheckbox, { name: filter, checked: (0, lodash_es_1.includes)(state, filter), onChange: () => onChange(filter), label: translate((0, translations_1.getNotificationFilterTranslation)(filter)), trackingId: `notification_list-filters-${identifier}-${filter}` }) }, filter)))] }));
};
exports.NotificationListFilterCheckboxList = NotificationListFilterCheckboxList;
//# sourceMappingURL=NotificationListFilterCheckboxList.js.map